import React from 'react';
import { useTranslation } from 'react-i18next';
import { LockIcon } from '@hero/web-icons';
import { Spinner } from '../../../app/Spinner';

export interface BillingRedirectOverlayProps {
  open: boolean;
}

/**
 * Full-screen handoff overlay shown between the `subscribe` API call
 * and the actual `window.location.assign(checkoutUrl)`. Stays mounted
 * until the browser actually navigates away so there's no flash of
 * empty UI between dialog dismissal and the Moyasar page paint.
 */
export function BillingRedirectOverlay({ open }: BillingRedirectOverlayProps) {
  const { t } = useTranslation('m-billing');
  if (!open) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-0 z-[60] flex items-center justify-center bg-white/85 backdrop-blur-sm">
      <div className="flex w-full max-w-sm flex-col items-center gap-5 rounded-2xl bg-white p-8 text-center shadow-xl ring-1 ring-gray-100">
        <Spinner className="size-10 text-primary" />
        <div className="flex flex-col gap-1">
          <h3 className="text-base font-semibold text-gray-900">
            {t('checkout.redirect_overlay.title')}
          </h3>
          <p className="text-sm text-gray-500">
            {t('checkout.redirect_overlay.description')}
          </p>
        </div>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-gray-50 px-3 py-1 text-[11px] font-medium text-gray-600">
          <LockIcon className="size-3 text-gray-400" />
          {t('checkout.redirect_overlay.processed_by_moyasar')}
        </span>
      </div>
    </div>
  );
}
